<template>
  <el-card class="historico-card">
    <div class="responsive-container">
      <div class="responsive-item">
        <div class="title">Número:</div>
        <div>{{ data.numero }}</div>
      </div>
      <div class="responsive-item">
        <div class="title">Modalidade:</div>
        <div>{{ data.modalidade }}</div>
      </div>
      <div class="responsive-item">
        <div class="title">Emissão:</div>
        <div>{{ data.ativacao }}</div>
      </div>
      <div class="responsive-item">
        <div class="title">Vencimento:</div>
        <div>{{ data.vencimento }}</div>
      </div>
      <div class="responsive-item">
        <div class="title">Status:</div>
        <div><StatusBadge :status="data.status" :historico="true" /></div>
      </div>
      <div class="responsive-item">
        <div class="title"></div>
        <div class="custom-dropdown-wrapper">
          <span
            class="el-dropdown-link"
            @click="toggleDropdown"
            v-if="
              data.status === 'Vigente' ||
                data.status === 'Invalidado' ||
                data.status === 'Aguardando pagamento do boleto' ||
                data.status === 'Vencido'
            "
          >
            <img src="@/assets/acoes.svg" alt="Ações" class="acoes-icon" />
          </span>
          <transition name="dropdown-fade">
            <div
              v-if="dropdownOpen"
              class="custom-dropdown-menu custom-dropdown-menu-right"
              @click.self="closeDropdown"
            >
              <ul>
                <li
                  v-if="data.status === 'Vigente'"
                  @click="gerarCarteira(data.numero)"
                >
                  Baixar PDF
                </li>
                <li
                  v-if="data.status === 'Aguardando pagamento do boleto'"
                  @click="gerarBoleto(data.numero)"
                >
                  Baixar Boleto
                </li>
                <li
                  v-if="
                    data.status === 'Vencido' || data.status === 'Invalidado'
                  "
                  class="solicitar-carteira-link"
                  @click="abrirNovoCadastro"
                >
                  <span>Solicitar Carteira</span>
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import ApiService2 from "../../../services/shared/ApiService2";
import StatusBadge from "../../shared/StatusBadge.vue";

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dropdownOpen: false
    };
  },
  components: {
    StatusBadge
  },
  methods: {
    gerarBoleto(protocolo) {
      this.closeDropdown();
      const protocoloDesformatado = protocolo
        .replace(/\//g, "")
        .replace(/-/g, "");

      ApiService2.downloadGet(
        "/api/boleto",
        { protocolo: protocoloDesformatado },
        "boleto-licenca-pesca.pdf"
      ).catch(() => {});
    },
    gerarCarteira(protocolo) {
      this.closeDropdown();
      const protocoloDesformatado = protocolo
        .replace(/\//g, "")
        .replace(/-/g, "");

      ApiService2.downloadGet(
        "/api/public/carteira",
        { protocolo: protocoloDesformatado },
        "carteira-licenca-pesca.pdf",
        true
      ).catch(() => {});
    },
    abrirNovoCadastro() {
      this.closeDropdown();
      this.$router.push({ name: "novoCadastro" });
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.closeDropdown();
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>

<style scoped>
.historico-card {
  padding: 15px;
  border-radius: 8px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 12px;
}

.title {
  font-weight: 700;
  margin-bottom: 5px;
}

.responsive-container {
  display: flex;
  flex-wrap: nowrap;
  gap: 20px;
}

.responsive-item {
  flex: 1;
  box-sizing: border-box;
}

.acoes-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-top: 10px;
}

.solicitar-carteira-link {
  text-decoration: unset;
  cursor: pointer;
  color: #303133;
}

.custom-dropdown-wrapper {
  position: relative;
  display: inline-block;
  font-size: 14px;
}

.custom-dropdown-menu {
  position: absolute;
  top: 0;
  left: 100%;
  margin-left: 1px;
  background: #fff;
  border: 1px solid #e4e4e4;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  width: auto;
  white-space: nowrap;
  z-index: 2000;
}

.custom-dropdown-menu-right {
  /* Garante alinhamento à direita do ícone */
  left: 100%;
  right: auto;
  top: 0;
  margin-left: 8px;
}

.custom-dropdown-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.custom-dropdown-menu li {
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.2s;
}

.custom-dropdown-menu li:hover {
  background: #f5f7fa;
}

.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}
.dropdown-fade-enter-from,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.dropdown-fade-enter-to,
.dropdown-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}

@media (max-width: 768px) {
  .responsive-container {
    flex-wrap: wrap;
    gap: 10px;
  }

  .responsive-item {
    flex: 1 1 45%;
  }

  .custom-dropdown-menu-right {
    margin-top: -40px;
    left: 0;
    margin-left: 0;
  }
}
</style>
